module.exports = __webpack_public_path__ + "static/media/notifications-activer-active.a43924e7.png";